import {connect} from "react-redux"
import {REALM_HEADER} from "@next/utils"
import State from "../../models/state"
import {
    setSelectedColourwayAction,
    setAnimateFavouriteIcon,
    setSelectedColourchipAction,
} from "../../ducks/productSummary"

export const mapStateToProps = ({template, request}: State) => {
    return {
        templating: template,
        client: request.headers[REALM_HEADER] as string,
    }
}

export const mapDispatchToProps = dispatch => {
    return {
        setMatchingColourWay: (itemNumber: string, index: number) => {
            dispatch(setSelectedColourwayAction(itemNumber))
            dispatch(setAnimateFavouriteIcon(false))
            dispatch(setSelectedColourchipAction(index))
        },
    }
}

export default connect(mapStateToProps, mapDispatchToProps)
